$(document).on 'ready page:load', ->
  $('#participation_invitee_role').change (e) ->
    window.location = '/interactions/' + this.dataset.target + '/participations/new?interactions_participation[role]=' + $(this).find('option:selected').val()
